define('app/utils',['jquery','backbone'], function($){

  var iphone = navigator.userAgent.match(/iPhone/i);
  var ipad = navigator.userAgent.match(/iPad/i);

  /*if(iphone || ipad) {
    var viewportmeta = document.querySelector('meta[name="viewport"]');
    if(viewportmeta){
      viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
      document.body.addEventListener('gesturestart', function () {
        viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
      }, false);
    }

     prevent scrolling in landscape mode
    if($(window).width() > $(window).height()){
      $(document).on('touchmove',function(e){
        e.preventDefault();
      });

      $('body').on('touchstart','.scrollable',function(e) {
        if (e.currentTarget.scrollTop === 0) {
          e.currentTarget.scrollTop = 1;
        } else if (e.currentTarget.scrollHeight === e.currentTarget.scrollTop + e.currentTarget.offsetHeight) {
          e.currentTarget.scrollTop -= 1;
        }
      });

      $('body').on('touchmove','.scroll',function(e) {
        e.stopPropagation();
      });
    }
  }*/

  window.shareToFacebook = function(path, title, image, desc){
    var hash = '';
    if(path.toString().indexOf('#') > -1) {
      hash = '#'+path.toString().split('#')[1];
      var preHash = path.toString().split('#')[0];
      path = preHash;
    }

    var encoded = encodeURIComponent(path + (path.indexOf('?') >= 0 ? '&' : '?') + 'fb=1&t=' + title + '&d=' + desc + '&i=' + image + hash);
    window.open('http://www.facebook.com/share.php?u=' + encoded,'_blank','titlebar=no,statusbar=no,menubar=no,scrollbars=no,width=600,height=400');
  }

  window.shareToGoogle = function(path, title, image, desc){
    var hash = '';
    if(path.toString().indexOf('#') > -1) {
      hash = '#' + path.toString().split('#')[1];
      var preHash = path.toString().split('#')[0];
      path = preHash;
    }
    if(path.charAt(path.length - 1) == '?')
      path = path.substr(0,path.length - 2);

    var encoded = encodeURIComponent(path + (path.indexOf('?') >= 0 ? '&' : '?') + 'gp=1&t=' + title + '&d=' + desc + '&i=' + image + hash);
    window.open('https://plus.google.com/share?url=' + encoded,'_blank','titlebar=no,statusbar=no,menubar=no,scrollbars=no,resizeable=no,width=600,height=400');
  }

  window.shareToTwitter = function(url, msg){
    window.open('/twitter-share/?message=' + msg + '&url=' + url.replace('#','%23'),'_blank','titlebar=no,statusbar=no,menubar=no,scrollbars=no,width=600,height=400');
  }

  window.preventDefault = function(e){
    e.preventDefault();
    e.stopPropagation();
  }

  window.flattenQuery = function(query){
    if(query.results && (query.results.COLUMNS && query.results.DATA)){
      var arr = [];
      for(var i = 0; i < query.results.DATA.length; i++){
        arr.push(_.object(query.results.COLUMNS, query.results.DATA[i]));
      }
      query.results = arr.length == 1 ? _.first(arr) : arr;

    }

    return query;
  }

  window.getQueryString = function() {
    var result = {}, queryString = location.search.substring(1);
    var re = /([^&=]+)=([^&]*)/g, m;

    while (m = re.exec(queryString)) {
      result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }

    return result;
  }

  window.formatLink = function(link){
    var sr = SITE_ROOT.replace(/^h?t?t?p?:?\/?\/?/, '');
    var l = {};

    l.href = 'http://' + link.replace(/^h?t?t?p?:?\/?\/?/, '');
    l.target = l.href.indexOf(sr) >= 0 ? '_self' : '_blank';

    return l;
  }

  $.fn.nextOrFirst = function(selector){
    var next = this.next(selector);
    return (next.length) ? next : this.prevAll(selector).last();
  };

  $.fn.prevOrLast = function(selector){
    var prev = this.prev(selector);
    return (prev.length) ? prev : this.nextAll(selector).last();
  };

  function getNthIndex(cur, dir) {
    var t = cur, idx = 0;
    while (cur = cur[dir] ) {
      if (t.tagName == cur.tagName) {
        idx++;
      }
    }
    return idx;
  }

  function isNthOf(elm, pattern, dir) {
    var position = getNthIndex(elm, dir), loop;
    if (pattern == 'odd' || pattern == 'even') {
      loop = 2;
      position -= !(pattern == 'odd');
    } else {
      var nth = pattern.indexOf('n');
      if (nth > -1) {
        loop = parseInt(pattern, 10) || parseInt(pattern.substring(0, nth) + '1', 10);
        position -= (parseInt(pattern.substring(nth + 1), 10) || 0) - 1;
      } else {
        loop = position + 1;
        position -= parseInt(pattern, 10) - 1;
      }
    }
    return (loop<0 ? position<=0 : position >= 0) && position % loop == 0
  }

  var pseudos = {
    'first-of-type': function(elm) {
      return getNthIndex(elm, 'previousSibling') == 0;
    },
    'last-of-type': function(elm) {
      return getNthIndex(elm, 'nextSibling') == 0;
    },
    'only-of-type': function(elm) {
      return pseudos['first-of-type'](elm) && pseudos['last-of-type'](elm);
    },
    'nth-of-type': function(elm, i, match) {
      return isNthOf(elm, match[3], 'previousSibling');
    },
    'nth-last-of-type': function(elm, i, match) {
      return isNthOf(elm, match[3], 'nextSibling');
    }
  }

  $.extend($.expr[':'], pseudos);

  /* JQUERY PSUEDO SELECTOR */
  $.expr[':'].internal = function(obj, index, meta, stack){
    //Prepare
    var $this = $(obj);
    var url = $this.attr('href')||'';
    var isInternalLink;

    //Check link
    isInternalLink = url.indexOf(SITE_ROOT) >= 0 || url.indexOf(':') === -1;

    //Ignore or Keep
    return isInternalLink;
  }

  /* JQUERY PSUEDO SELECTOR */
  $.expr[':'].ajaxform = function(obj, index, meta, stack){
    //Prepare
    var $this = $(obj);
    var action = $this.attr('action') || '';
    var isAjaxForm;

    //Check link
    isAjaxForm = action.substring(0, AJAX_PATH.length) === AJAX_PATH;

    //Ignore or Keep
    return isAjaxForm;
  }

  /*!
   * jQuery.fn.hasAttr()
   *
   * Copyright 2011, Rick Waldron
   * Licensed under MIT license.
   *
   */
    $.fn.hasAttr = function( name ) {
      for ( var i = 0, l = this.length; i < l; i++ ) {
        if ( !!( this.attr( name ) !== undefined ) ) {
          return true;
        }
      }
      return false;
    };

});
